/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ESRS areas

Values: climate_change=ClimateChange, pollution=Pollution, water_and_marine_sources=WaterAndMarineSources, biodiversity_and_ecosystems=BiodiversityAndEcosystems, circular_economy=CircularEconomy, own_workforce=OwnWorkforce, workers_in_value_chain=WorkersInValueChain, affected_communities=AffectedCommunities, consumers_and_end_users=ConsumersAndEndUsers, business_conduct=BusinessConduct, other=Other
 * @export
 * @enum {string}
 */

export enum DoubleMaterialityStakeholderESRSArea {
    ClimateChange = 'climate_change',
    Pollution = 'pollution',
    WaterAndMarineSources = 'water_and_marine_sources',
    BiodiversityAndEcosystems = 'biodiversity_and_ecosystems',
    CircularEconomy = 'circular_economy',
    OwnWorkforce = 'own_workforce',
    WorkersInValueChain = 'workers_in_value_chain',
    AffectedCommunities = 'affected_communities',
    ConsumersAndEndUsers = 'consumers_and_end_users',
    BusinessConduct = 'business_conduct',
    Other = 'other'
}


